/* @flow */

import React from 'react';
import { Button, Menu } from 'semantic-ui-react';
import AddTargetButton from './AddTargetButton';

type Props = {
  isFetching: boolean,
  isEditable: boolean,
  roles: Array<UserRole>,
  onClear: () => void,
  onAdd: (target: Target) => void,
  attached?: boolean,
};

const styles = {
  buttons: {
    clear: {
      height: '36px',
    },
  },
};

const DiffusionHeader = ({
  isFetching,
  isEditable,
  roles,
  onClear,
  onAdd,
  attached,
}: Props) => {
  return (
    <Menu size="small" attached={attached || 'top'}>
      <Menu.Item header className="borderless">
        Liste de diffusion
      </Menu.Item>
      {isEditable && (
        <Menu.Menu position="right">
          <Menu.Item>
            <Button
              style={styles.buttons.clear}
              loading={isFetching}
              type="button"
              icon="recycle"
              content="Vider"
              labelPosition="left"
              onClick={onClear}
            />
          </Menu.Item>
          <Menu.Item>
            <AddTargetButton
              isFetching={isFetching}
              roles={roles}
              onTargetAdded={onAdd}
            />
          </Menu.Item>
        </Menu.Menu>
      )}
    </Menu>
  );
};

export default DiffusionHeader;



// WEBPACK FOOTER //
// ./src/modules/diffusion/components/DiffusionHeader.js